export enum FinanceType {
  Cash = 'CASH',
  Finance = 'FINANCE',
  Lease = 'LEASE',
  Balloon = 'BALLOON'
}
